module.exports = __webpack_public_path__ + "media/images/twitter_badge-87e7cbc8.png";